// extracted by mini-css-extract-plugin
export var createdDate = "_ho-1";
export var divider = "_ho-2";
export var headerDivider = "_ho-3";
export var messagesCard = "_ho-0";
export var messagesContainer = "_ho-6";
export var messagesContainerWrapper = "_ho-4";
export var showLeftPanelButton = "_ho-8";
export var topButtons = "_ho-7";
export var withPadding = "_ho-5";